import { useAuth0 } from '@auth0/auth0-react'
import { ErrorOutline, Refresh } from '@mui/icons-material'
import { Box, Container, Stack, Typography } from '@mui/material'
import Cookies from 'js-cookie'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import Button from '@/components/Button'
import { getProfileApi } from '@/utils/appApi'

const SomethingWentWrong: React.FC = () => {
  const navigate = useNavigate()
  const { logout } = useAuth0()

  const handleLogout = () => {
    Cookies.remove('session_id')
    logout({
      logoutParams: { returnTo: window.location.origin },
    })
  }

  const handleRetry = () => {
    getProfileApi()
      .then(() => {
        navigate('/')
      })
      .catch(() => {
        window.location.reload()
      })
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(1200px 600px at 50% -10%, rgba(211,47,47,0.18), transparent 60%), linear-gradient(180deg, #0b0b0e 0%, #111216 100%)',
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            p: { xs: 3, sm: 4 },
            borderRadius: '20px',
            background:
              'linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))',
            border: '1px solid rgba(255,255,255,0.08)',
            backdropFilter: 'blur(8px)',
            boxShadow: '0 30px 80px rgba(0,0,0,0.45)',
            textAlign: 'center',
          }}
        >
          {/* Icon */}
          <Box
            sx={{
              mx: 'auto',
              mb: 2.5,
              width: 120,
              height: 120,
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              background:
                'conic-gradient(from 180deg at 50% 50%, rgba(211,47,47,0.35), rgba(211,47,47,0.08), rgba(211,47,47,0.35))',
              animation: 'pulse 2.4s ease-in-out infinite',
              '@keyframes pulse': {
                '0%, 100%': { boxShadow: '0 0 0 0 rgba(211,47,47,0.35)' },
                '50%': { boxShadow: '0 0 0 14px rgba(211,47,47,0)' },
              },
            }}
          >
            <Box
              sx={{
                width: 92,
                height: 92,
                borderRadius: '50%',
                display: 'grid',
                placeItems: 'center',
                backgroundColor: 'rgba(211, 47, 47, 0.14)',
              }}
            >
              <ErrorOutline sx={{ fontSize: 56, color: '#ff6b6b' }} />
            </Box>
          </Box>

          {/* Title */}
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 800,
              letterSpacing: '-0.02em',
              color: '#ffffff',
              mb: 1,
            }}
          >
            Something went wrong
          </Typography>

          {/* Subtitle */}
          <Typography
            variant="body1"
            sx={{
              color: 'rgba(255,255,255,0.75)',
              mb: 3,
              maxWidth: 420,
              mx: 'auto',
              lineHeight: 1.7,
            }}
          >
            An unexpected error occurred. You can try again, or log out and sign
            back in.
          </Typography>

          {/* Actions */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            justifyContent="center"
            sx={{ mb: 2.5 }}
          >
            <Button
              variant="outlined"
              startIcon={<Refresh />}
              onClick={handleRetry}
              label="Try Again"
            />

            <Button
              variant="contained"
              onClick={handleLogout}
              disableElevation
              label="Logout"
            />
          </Stack>
        </Box>
      </Container>
    </Box>
  )
}

export default SomethingWentWrong
